/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Capture-list filter over TriggerSource, plus NONE for captures with no
 * recorded trigger (manual catch logs, firmware that predates the field).
 * Kept separate from TriggerSource because the device never writes "none".
 * @export
 */
export const TriggerSourceFilter = {
    Button: 'button',
    Weight: 'weight',
    Api: 'api',
    None: 'none',
} as const;
export type TriggerSourceFilter = typeof TriggerSourceFilter[keyof typeof TriggerSourceFilter];


export function instanceOfTriggerSourceFilter(value: any): boolean {
    for (const key in TriggerSourceFilter) {
        if (Object.prototype.hasOwnProperty.call(TriggerSourceFilter, key)) {
            if (TriggerSourceFilter[key as keyof typeof TriggerSourceFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TriggerSourceFilterFromJSON(json: any): TriggerSourceFilter {
    return TriggerSourceFilterFromJSONTyped(json, false);
}

export function TriggerSourceFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerSourceFilter {
    return json as TriggerSourceFilter;
}

export function TriggerSourceFilterToJSON(value?: TriggerSourceFilter | null): any {
    return value as any;
}

export function TriggerSourceFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): TriggerSourceFilter {
    return value as TriggerSourceFilter;
}

